import React, { useEffect, useRef, useState } from 'react';
// reactstrap components
import { Button, Col, Row } from 'reactstrap';
import { useFileUtils } from 'hooks';
import ProfileInitials from './ProfileInitials';
import { useSelector } from 'react-redux';
import { useTranslate } from 'react-translate';
import ImageCropModal from 'components/ImageCrop/ImageCropModal';
import { useDispatch } from 'react-redux';

const ProfileAvatar = ({ setAvatar, avatar }) => {
  const t = useTranslate('profile');
  const dispatch = useDispatch();
  const imagePrevRef = useRef();
  const user = useSelector((state) => state.userReducer);
  const inputAvatar = document.getElementById('profile-picture');

  const [showImageCrop, setShowImageCrop] = useState(false);
  const toggle = () => setShowImageCrop(!showImageCrop);

  const {
    getAvatar,
    deleteAvatar,
    defaultImage,
    resetInput,
    setFile,
    avatarExists,
  } = useFileUtils(inputAvatar);

  useEffect(() => {
    if (user.avatar) {
      const avatarResponse = getAvatar(user.avatar, 'large', true);
      avatarResponse.then((avatar) => {
        if (avatar) {
          setFile({ file: avatar });
        }
      });
    }
    //eslint-disable-next-line
  }, [user.avatar, setFile, user.updated_at]);

  useEffect(() => {
    if (defaultImage.includes('General')) {
      resetInput();
    }
    //eslint-disable-next-line
  }, [defaultImage]);

  const deleteAvatarEffect = () => {
    if (avatar) {
      setAvatar(null);
      inputAvatar.value = null;
      imagePrevRef.current.src = defaultImage;
      return;
    }
    console.log(user);
    const response = deleteAvatar(user.auth_user_id);
    response.then(() => {
      inputAvatar.value = null;
    });
  };

  return (
    <>
      <ImageCropModal
        toggle={toggle}
        showImageCrop={showImageCrop}
        imageInputId="profile-picture"
        imagePreviewId="avatar-preview"
        defaultImage={defaultImage}
        setAvatar={setAvatar}
      />

      <div className="profile-img-container mr-6">
        <div className="profile-img">
          <img
            src={defaultImage}
            id="avatar-preview"
            alt="Profile avatar"
            ref={imagePrevRef}
            className={avatarExists || avatar ? '' : 'd-none'}
          />

          <div
            className={`text-center remove ${
              avatarExists || avatar ? '' : 'd-none'
            }`}
            title="remove"
            onClick={deleteAvatarEffect}
          >
            X
          </div>
        </div>
        <Row>
          <Col>
            <Button
              className="mt-3 btn-profile-photo"
              color="info"
              name="btn-img-avatar"
              size="sm"
              onClick={() => {
                document.getElementById('profile-picture').click();
              }}
            >
              {t('avatar-upload')}
            </Button>
          </Col>
        </Row>

        <input
          type="file"
          name="avatar_input"
          id="profile-picture"
          accept="image/jpeg,image/png"
          className="d-none"
          defaultValue={null}
        />
      </div>
    </>
  );
};

export default ProfileAvatar;
